import { useState } from 'react';

const WA_NUMBER = '584128334239';
const WA_MESSAGE = encodeURIComponent('Hola, me gustaría obtener información sobre los productos químicos de Poly Alphas Chemicals C.A.');

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);

  // Hide tooltip after 4 seconds
  useState(() => {
    const t = setTimeout(() => setShowTooltip(false), 4000);
    return () => clearTimeout(t);
  });

  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      onMouseEnter={() => { setHovered(true); setShowTooltip(true); }}
      onMouseLeave={() => setHovered(false)}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 cursor-pointer group"
      style={{ filter: 'drop-shadow(0 4px 16px rgba(37,211,102,0.45))' }}
    >
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          hovered || showTooltip ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        <div
          className="px-4 py-2.5 rounded-xl text-sm font-500 whitespace-nowrap"
          style={{
            background: '#1a1a2e',
            border: '1px solid rgba(37,211,102,0.3)',
            color: '#fff',
            boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
          }}
        >
          <span className="text-xs text-green-400 block font-600 mb-0.5">¡Escríbenos!</span>
          +58 412 833 4239
        </div>
        {/* Arrow */}
        <div
          className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2"
          style={{
            width: 0, height: 0,
            borderTop: '6px solid transparent',
            borderBottom: '6px solid transparent',
            borderLeft: '8px solid rgba(37,211,102,0.3)',
          }}
        />
      </div>

      {/* Button circle */}
      <div
        className={`relative w-14 h-14 flex items-center justify-center rounded-full transition-transform duration-300 ${hovered ? 'scale-110' : 'scale-100'}`}
        style={{ background: 'linear-gradient(135deg, #25D366, #128C7E)' }}
      >
        {/* Ping animation */}
        <div
          className="absolute inset-0 rounded-full animate-ping opacity-30"
          style={{ background: '#25D366' }}
        />
        <i className="ri-whatsapp-line text-white text-3xl relative z-10" />
      </div>
    </a>
  );
}